import { apiClient } from "../../../lib/apiClient";
import type { ApiResponse } from "../../../types/apiResponse";
import type { QuoteProduct } from "../types";

export const fetchAddNewProduct = (payload: QuoteProduct) => {
   return apiClient<ApiResponse>("/v1/quote/product", {
      method: "POST",
      body: payload
   })
}
